import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { A as y, a as m } from "../Avatar-BklEyPdJ.js";
import { B as g } from "../Button-BDQYwrrG.js";
import { c as h } from "../clsx-OuTLNxxd.js";
import "../Profile.css?__remix_sideEffect__";const d = "320px",r = "600px",f = "1025px",_ = "_isVisuallyHidden_ct3r5_52",H = "_profile_ct3r5_64",z = "_image_ct3r5_68",u = "_name_ct3r5_75",p = "_description_ct3r5_80",b = "_link_ct3r5_81",S = "_details_ct3r5_109",e = {
    mobile: d,
    "mobile-wide": "480px",
    tablet: r,
    "tablet-wide": "800px",
    desktop: f,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: _,
    profile: H,
    image: z,
    name: u,
    description: p,
    link: b,
    "layout-column": "_layout-column_ct3r5_102",
    "layout-row": "_layout-row_ct3r5_106",
    details: S,
    "size-s": "_size-s_ct3r5_116",
    "size-m": "_size-m_ct3r5_121",
    "size-l": "_size-l_ct3r5_132"
  },v = ({
    name: l,
    image: s,
    description: x,
    layout: c = "column",
    profileLink: i,
    size: a = "m",
    ...n
  }) => /* @__PURE__ */o(
    "div",
    {
      ...n,
      className: h(
        e.profile,
        e[`size-${a}`],
        e[`layout-${c}`],
        n.className
      ),
      children: [
      /* @__PURE__ */t(y, { className: e.image, children: /* @__PURE__ */t(m, { alt: `Image of ${l}`, src: s }) }),
      /* @__PURE__ */o("div", { className: e.details, children: [
        /* @__PURE__ */t("h3", { className: e.name, children: l }),
        x && /* @__PURE__ */t("p", { className: e.description, children: x }),
        i && /* @__PURE__ */t(g, { variant: "ghostBrand", className: e.link, asChild: !0, children: /* @__PURE__ */t("a", { href: i.href, children: i.text }) })]
      })]

    }
  );
export {
  v as Profile };